// src/layouts/ClipsLayout.jsx
import React from "react";
import { Outlet } from "react-router-dom";

export default function ClipsLayout() {
  return (
    <div
      style={{
        height: "100dvh",
        overflow: "hidden",
        background: "#000",
      }}
    >
      <Outlet />
    </div>
  );
}